/* React base component */
import { Component } from "react"

/* Component Loading */
class Loading extends Component {

    render = () => {
        return (
            <div className="loading" style={this.props.inline ? { padding: "40px 0" } : undefined}>
                <span className="loading__spinner" />
            </div>
        )
    }
}

/* Export */
export default Loading
